//
//
//
//
//
//
//
//

import SimplePage from '@/components/SimplePage'
export default {
  components: {
    SimplePage
  },
  data() {
    return {}
  },
  computed: {
    prj_code() {
      return this.$store.state.app.prj_code
    }
  },
  created() {
    if (this.prj_code && this.$route.fullPath.indexOf(this.prj_code) == -1) {
      var url = '/' + this.prj_code + this.$route.fullPath;
      this.$router.push(url);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Index.vue